<div class="dashboard--module-header">
    <h2 class="subheading-sm">Billing History <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<billing-history-bills-chart class="module--main" [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData" class="module--main"></billing-history-bills-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>
